export default "__VITE_ASSET__C8HuRo6E__"